<template>
    <div class="blackjack-overview">
        <div class="blackjack-banner-section">
            <div class="blackjack-title-container">
                <h1 class="blackjack-title">BLACK JACK</h1>
                <p class="blackjack-subtitle">Beat the dealer. Play smart. Win big.</p>
            </div>
            <img src="@/assets/img/blackjack/background.png" alt="Blackjack Banner Background" class="blackjack-banner-background" />
        </div>
        <div class="overview-standard">
            <div class="standard-header">
                <div class="header-title">
                    <img src="@/assets/img/blackjack/Standard.svg" alt="Standard Tables" class="header-icon" />
                    <span>STANDARD TABLES</span>
                    <div class="title-limits">
                        [
                        <span class="coin-wrapper"><IconCoin /></span>
                        <div class="limits-value">
                            <span>1</span> <span>- 100</span>
                        </div>
                        ]
                    </div>
                </div>
                <div v-on:click="blackjackToggleLoadMore('standard')" class="link-load-more">
                    <!-- <span>{{blackjackDisplayedCount.standard}}/{{blackjackTotalCount.standard}} Load More</span> -->
                                        <span>{{blackjackDisplayedCount.standard}}/10 Load More</span>

                    <IconDropdown />
                </div>
            </div>
            <div class="standard-content">
                <transition name="fade" mode="out-in">
                    <div v-if="showLoading" class="content-loading" key="loading">

                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>

                    </div>
                    <div v-else class="content-list" key="data">
                        <transition-group name="table-fade" tag="div" class="content-list-wrapper">
                            <BlackjackTablesElement v-if="blackjackGetTables.standard.length > 0" v-for="(table, index) of blackjackGetTables.standard.slice(0, blackjackDisplayLimit.standard)" v-bind:key="table.table" v-bind:table="table" v-bind:display-number="index + 1" />
                        </transition-group>
                        <div v-if="blackjackGetTables.standard.length === 0" class="content-empty">
                            <p>No tables available at the moment. Please try again later.</p>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <div class="overview-whale">
            <div class="whale-header">
                <div class="header-title">
                    <img src="@/assets/img/blackjack/Whales.svg" alt="Whale Tables" class="header-icon" />
                    <span>WHALE TABLES</span>
                    <div class="title-limits">
                        [
                        <span class="coin-wrapper"><IconCoin /></span>
                        <div class="limits-value">
                            <span>25</span><span>- 1000</span>
                        </div>
                        ]
                    </div>
                </div>
                <div v-on:click="blackjackToggleLoadMore('whale')" class="link-load-more">
                    <!-- <span>{{blackjackDisplayedCount.whale}}/{{blackjackTotalCount.whale}} Load More</span> -->
                    <span>{{blackjackDisplayedCount.whale}}/10 Load More</span>

                    <IconDropdown />
                </div>
            </div>
            <div class="whale-content">
                <transition name="fade" mode="out-in">
                    <div v-if="showLoading" class="content-loading" key="loading">

                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>

                    </div>
                    <div v-else class="content-list" key="data">
                        <transition-group name="table-fade" tag="div" class="content-list-wrapper">
                            <BlackjackTablesElement v-if="blackjackGetTables.whale.length > 0" v-for="(table, index) of blackjackGetTables.whale.slice(0, blackjackDisplayLimit.whale)" v-bind:key="table.table" v-bind:table="table" v-bind:display-number="index + 11" />
                        </transition-group>
                        <div v-if="blackjackGetTables.whale.length === 0" class="content-empty">
                            <p>No whale tables available at the moment. Please try again later.</p>
                        </div>
                    </div>
                </transition>
            </div>
        </div>

        <Bets />
    </div>
</template>

<script>
        import IconCoin from '@/components/icons/IconCoin';
    import { mapGetters, mapActions } from 'vuex';
    import Bets from '@/components/bets/Bets';
    import IconTables from '@/components/icons/IconTables';
    import IconDropdown from '@/components/icons/IconDropdown';
    import BlackjackTablesElement from '@/components/blackjack/BlackjackTablesElement';

    export default {
        name: 'BlackjackOverview',
        components: {
            Bets,
            IconTables,
            IconDropdown,
            BlackjackTablesElement,
                IconCoin
        },
        data() {
            return {
                connectionTimeout: false,
                blackjackDisplayLimit: {
                    standard: 4,
                    whale: 4
                }
            }
        },
        methods: {
            blackjackToggleLoadMore(type) {
                if (this.blackjackDisplayLimit[type] >= 10) {
                    this.blackjackDisplayLimit[type] = 4;
                } else {
                    this.blackjackDisplayLimit[type] = 10;
                    // Smooth scroll to show new content after animation
                    this.$nextTick(() => {
                        const headerElement = type === 'standard' 
                            ? document.querySelector('.overview-standard .standard-header')
                            : document.querySelector('.overview-whale .whale-header');
                        if (headerElement) {
                            setTimeout(() => {
                                headerElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                            }, 400);
                        }
                    });
                }
            }
        },
        mounted() {
            // Set timeout to show content even if socket doesn't connect
            setTimeout(() => {
                if (!this.socketBlackjack.connected) {
                    this.connectionTimeout = true;
                }
            }, 5000); // 5 second timeout
        },
        computed: {
            ...mapGetters(['socketBlackjack', 'blackjackTables']),
            blackjackGetTables() {
                let tables = { standard: [], whale: [] };

                for(const table of this.blackjackTables) {
                    if(table.game.type === 'standard') { tables.standard.push(table); }
                    else { tables.whale.push(table); }
                }

                return tables;
            },
            showLoading() {
                // Show loading only if socket is not connected AND timeout hasn't passed
                return !this.socketBlackjack.connected && !this.connectionTimeout;
            },
            blackjackDisplayedCount() {
                return {
                    standard: Math.min(this.blackjackDisplayLimit.standard, this.blackjackGetTables.standard.length),
                    whale: Math.min(this.blackjackDisplayLimit.whale, this.blackjackGetTables.whale.length)
                };
            },
            blackjackTotalCount() {
                return {
                    standard: Math.max(this.blackjackGetTables.standard.length, 10),
                    whale: Math.max(this.blackjackGetTables.whale.length, 10)
                };
            }
        },
        watch: {
            'socketBlackjack.connected'(connected) {
                // Reset timeout flag when socket connects
                if (connected) {
                    this.connectionTimeout = false;
                }
            }
        }
    }
</script>

<style scoped>
    .blackjack-overview {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 45px 10px;
        z-index: 1;
    }

    .blackjack-banner-section {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        overflow: hidden;
        padding: 0 100px;
    }

    .blackjack-banner-background {
        width: 100%;
        max-width: 100%;
        height: auto;
        display: block;
        object-fit: cover;
        position: relative;
        z-index: 1;
    }

    .blackjack-title-container {
        position: absolute;
        left: 100px;
        top: 0;
        z-index: 2;
        display: flex;
        align-items: baseline;
        gap: 20px;
        flex-wrap: nowrap;
        margin: 90px 0 0 45px;
    }

    .blackjack-title {
        font-family: 'Anton SC', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 64px;
        line-height: 69px;
        letter-spacing: 0%;
        color: var(--gradient-txt-yellow);
        background: var(--gradient-txt-yellow);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        display: inline-block;
    }

    .blackjack-subtitle {
        font-family: 'Anton', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: 0%;
        color: #ffffff;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        display: inline-block;
    }

    .blackjack-overview .overview-standard,
    .blackjack-overview .overview-whale {
        width: 100%;
        max-width: 1300px;
    }

    .blackjack-overview .overview-whale {
        width: 100%;
        max-width: 1300px;
        margin-top: 50px;
    }

    .blackjack-overview .standard-header,
    .blackjack-overview .whale-header {
        width: 100%;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 25px;
        border-bottom: 1px solid var(--accent-yellow);
    }

    .blackjack-overview .header-title {
        display: flex;
        align-items: center;
    }

    .blackjack-overview .header-title svg,
    .blackjack-overview .header-title .header-icon {
        margin-right: 12px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
    }

    .blackjack-overview .header-title span {
        font-size: 28px;
        font-weight: 900;
        color: #FFFFFF;
    }

    .blackjack-overview .title-limits {
        display: inline-flex;
        align-items: center;
        margin-left: 15px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        font-weight: 400;
        font-size: 28px;
        color: #FFFFFF;
        line-height: 1;
    }

    .blackjack-overview .limits-value {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        font-size: 12px;
        font-weight: 600;
        color: #FFFFFF;
        display: inline-flex;
        align-items: center;
        line-height: 1;
    }

    .blackjack-overview .limits-value span {
        font-size: 16px;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 1;
    }

    .blackjack-overview .title-limits .coin-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 6px;
        height: 16px;
        position: relative;
    }

    .blackjack-overview .title-limits .coin-wrapper svg {
        width: 16px;
        height: 16px;
        display: block;
    }

    .blackjack-overview .title-limits img,
    .blackjack-overview .title-limits svg {
        width: 16px;
        height: 16px;
        margin-right: 6px;
        flex-shrink: 0;
        vertical-align: middle;
    }

    .blackjack-overview .title-limits .limits-value {
        display: inline-flex;
        align-items: center;
        line-height: 1;
    }

    .blackjack-overview .standard-header .link-load-more,
    .blackjack-overview .whale-header .link-load-more {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        color: #FFFFFF;
        cursor: pointer;
        transition: all 0.3s ease;
        user-select: none;
    }

    .blackjack-overview .standard-header .link-load-more:hover,
    .blackjack-overview .whale-header .link-load-more:hover {
        opacity: 0.8;
        transform: translateY(-2px);
    }

    .blackjack-overview .standard-header .link-load-more:active,
    .blackjack-overview .whale-header .link-load-more:active {
        transform: translateY(0);
        transition: all 0.1s ease;
    }

    .blackjack-overview .standard-header .link-load-more svg,
    .blackjack-overview .whale-header .link-load-more svg {
        margin-left: 8px;
        width: 10px;
        height: 6px;
        display: flex;
        align-items: center;
    }

    .blackjack-overview .standard-content,
    .blackjack-overview .whale-content {
        margin: 25px -25px 0 -25px;
    }

    .blackjack-overview .content-loading {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    .blackjack-overview .content-loading.fade-leave-active {
        transition: opacity 0.5s;
    }

    .blackjack-overview .content-loading.fade-leave-to {
        opacity: 0;
    }

    .blackjack-overview .loading-placeholder {
        width: calc(20% - 8px);
        height: 150px;
        position: relative;
        margin-top: 10px;
        margin-right: 10px;
        overflow: hidden;
        background: radial-gradient(285% 150% at 50% 50%, #2a2a2a 0%, #1a1a1a 100%);
        border-radius: 20px;
    }

    .blackjack-overview .loading-placeholder:nth-child(1),
    .blackjack-overview .loading-placeholder:nth-child(2),
    .blackjack-overview .loading-placeholder:nth-child(3),
    .blackjack-overview .loading-placeholder:nth-child(4),
    .blackjack-overview .loading-placeholder:nth-child(5) {
        margin-top: 0;
    }

    .blackjack-overview .loading-placeholder:nth-child(5n) {
        margin-right: 0;
    }

    .blackjack-overview .loading-placeholder::after {
        width: 100%;
        height: 100%;
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        animation-name: loading_animation;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-iteration-count: infinite;
        background: linear-gradient(to right, #ffffff00 0%, rgba(255, 255, 255, 0.1) 50%, #ffffff00 100%);
    }

    .blackjack-overview .content-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        position: relative;
    }

    .blackjack-overview .content-list-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
    }


    .blackjack-overview .content-list.fade-enter-active {
        transition: opacity 0.5s;
    }

    .blackjack-overview .content-list.fade-enter-from {
        opacity: 0;
    }

    /* Smooth animation for table elements */
    .table-fade-enter-active {
        transition: all 0.4s ease-out;
    }

    .table-fade-leave-active {
        transition: all 0.3s ease-in;
    }

    .table-fade-enter-from {
        opacity: 0;
        transform: translateY(15px) scale(0.95);
    }

    .table-fade-leave-to {
        opacity: 0;
        transform: translateY(-10px) scale(0.95);
    }

    .table-fade-move {
        transition: transform 0.4s ease;
    }

    .blackjack-overview .content-empty {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 60px 20px;
        text-align: center;
    }

    .blackjack-overview .content-empty p {
        font-size: 16px;
        color: #6a88a1;
        margin: 0;
    }

    @keyframes loading_animation {
        0% { transform: translateX(-100%); }
        50% { transform: translateX(100%); }
        100% { transform: translateX(100%); }
    }

    @media only screen and (max-width: 1700px) {

        .blackjack-banner-section {
            margin-bottom: 15px;
            padding: 0 var(--spacing-md);
        }

        .blackjack-title-container {
            left: var(--spacing-md);
            gap: 15px;
        }

        .blackjack-title {
            font-size: 48px;
            line-height: 52px;
        }

        .blackjack-subtitle {
            font-size: 18px;
        }

        .blackjack-overview .overview-standard,
        .blackjack-overview .overview-whale {
            width: 100%;
        }

        .blackjack-overview .standard-content,
        .blackjack-overview .whale-content {
            margin: 25px 0 0 0;
        }

    }

    @media only screen and (max-width: 1050px) {

        .blackjack-overview .loading-placeholder {
            width: calc(25% - 7.5px);
        }

        .blackjack-overview .loading-placeholder:nth-child(5) {
            margin-top: 10px;
        }

        .blackjack-overview .loading-placeholder:nth-child(5n) {
            margin-right: 10px;
        }

        .blackjack-overview .loading-placeholder:nth-child(4n) {
            margin-right: 0;
        }

    }

    @media only screen and (max-width: 950px) {

        .blackjack-banner-section {
            margin-bottom: 10px;
            padding: 0 var(--spacing-sm);
        }

        .blackjack-title-container {
            left: var(--spacing-sm);
            gap: 12px;
            margin: 30px 0 0 5px;
        }

        .blackjack-title {
            font-size: 36px;
            line-height: 40px;
        }

        .blackjack-subtitle {
            font-size: 16px;
        }

        .blackjack-overview {
            padding: 25px 10px 443px 10px;
        }

    }

    @media only screen and (max-width: 900px) {

        .blackjack-overview .loading-placeholder {
            width: calc(33.33% - 6.66px);
        }

        .blackjack-overview .loading-placeholder:nth-child(4) {
            margin-top: 10px;
        }

        .blackjack-overview .loading-placeholder:nth-child(4n) {
            margin-right: 10px;
        }

        .blackjack-overview .loading-placeholder:nth-child(3n) {
            margin-right: 0;
        }

    }

    @media only screen and (max-width: 850px) {

        .blackjack-overview .standard-header,
        .blackjack-overview .whale-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 15px;
        }

        .blackjack-overview .header-title {
            flex-wrap: wrap;
            gap: 10px;
        }

        .blackjack-overview .standard-header .link-load-more,
        .blackjack-overview .whale-header .link-load-more {
            align-self: flex-end;
        }

    }

    @media only screen and (max-width: 700px) {

        .blackjack-overview {
            padding: 20px 10px 443px 10px;
        }

        .blackjack-banner-section {
            margin-bottom: 15px;
            padding: 0 var(--spacing-xs);
        }

        .blackjack-title-container {
            left: var(--spacing-xs);
            gap: 10px;
            margin: 30px 0 0 5px;
        }

        .blackjack-title {
            font-size: 28px;
            line-height: 32px;
        }

        .blackjack-subtitle {
            font-size: 14px;
        }

        .blackjack-overview .header-title {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
        }

        .blackjack-overview .header-title span {
            font-size: 22px;
        }

        .blackjack-overview .title-limits {
            margin-left: 0;
            font-size: 20px;
            flex-wrap: wrap;
        }

        .blackjack-overview .limits-value {
            font-size: 11px;
        }

        .blackjack-overview .limits-value span {
            font-size: 14px;
        }

        .blackjack-overview .standard-header,
        .blackjack-overview .whale-header {
            padding-bottom: 20px;
        }

        .blackjack-overview .standard-header .link-load-more,
        .blackjack-overview .whale-header .link-load-more {
            font-size: 14px;
            align-self: flex-start;
            margin-top: 5px;
        }

        .blackjack-overview .overview-whale {
            margin-top: 30px;
        }

        .blackjack-overview .loading-placeholder {
            width: calc(50% - 5px);
        }

        .blackjack-overview .loading-placeholder:nth-child(3) {
            margin-top: 10px;
        }

        .blackjack-overview .loading-placeholder:nth-child(3n) {
            margin-right: 10px;
        }

        .blackjack-overview .loading-placeholder:nth-child(2n) {
            margin-right: 0;
        }

    }

    @media only screen and (max-width: 480px) {

        .blackjack-overview {
            padding: 15px 5px 443px 5px;
        }

        .blackjack-banner-section {
            margin-bottom: 10px;
        }

        .blackjack-overview .header-title svg,
        .blackjack-overview .header-title .header-icon {
            width: 32px;
            height: 32px;
            margin-right: 8px;
        }

        .blackjack-overview .header-title span {
            font-size: 18px;
        }

        .blackjack-overview .title-limits {
            font-size: 16px;
            margin-left: 0;
        }

        .blackjack-overview .limits-value {
            font-size: 10px;
        }

        .blackjack-overview .limits-value span {
            font-size: 12px;
        }

        .blackjack-overview .title-limits .coin-wrapper svg {
            width: 14px;
            height: 14px;
        }

        .blackjack-overview .standard-header,
        .blackjack-overview .whale-header {
            padding-bottom: 15px;
        }

        .blackjack-overview .standard-header .link-load-more,
        .blackjack-overview .whale-header .link-load-more {
            font-size: 13px;
        }

        .blackjack-overview .overview-whale {
            margin-top: 25px;
        }

        .blackjack-overview .standard-content,
        .blackjack-overview .whale-content {
            margin: 20px -5px 0 -5px;
        }

    }
</style>
